import inView from "../src/utilites/inView.js";

function progressOnView( item ) {
    let it = item.querySelector('.bar'),
        pre = it.querySelector('.pre');
    pre.style.maxWidth = it.dataset.progress + '%';
}
export default function progressBar() {
    const items = document.querySelectorAll('.tz-progress');
    items.forEach( (item) => {
        inView( item,
            {threshold: 0.1},
            { onEnter: () => {
                    progressOnView(item);
            }}
        );
    } );
}